<template>
  <app-card>
    <v-form v-model="formValidate">
      <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
        <v-row justify="center">
          <!-- <v-col cols="12">
            <app-headline :title="title" class="mb-2 mt-n3" />
            <v-divider class="mb-3"></v-divider>
          </v-col> -->

          <v-col cols="12" md="6">
            <v-select
              v-model="form.LeaveTypeID"
              :items="leaveTypeDropdown"
              label="ประเภท"
              hide-details="auto"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.LeaveStatusID"
              :items="leaveStatusDropdown"
              label="สถานะ"
              hide-details="auto"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" md="6">
            <v-select
              v-model="form.Month"
              :items="leaveMonthDropdown"
              label="เดือน"
              hide-details="auto"
              outlined
              dense
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              v-model="form.Year"
              :items="leaveYearDropdown"
              label="ปี"
              hide-details="auto"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row justify="start">
          <v-col cols="12">
            <v-text-field
              v-model="form.Keyword"
              label="ค้นหาชื่อผู้เขียนใบลา"
              hint="*ค้นหาด้วยส่วนหนึ่งของชื่อ-สกุลของผู้ลา หรือรหัสใบลา"
              persistent-hint
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row class="mt-n5 mb-n2">
          <v-col cols="12">
            <v-btn
              @click="onSearch"
              class="float-right"
              color="primary darken-2"
              depressed
              large
            >
              <v-icon>
                mdi-magnify
              </v-icon>
              ค้นหา
            </v-btn>
            <v-btn
              @click="onClear"
              color="grey"
              class="white--text float-right mr-2"
              depressed
              large
              outlined
            >
              <v-icon>
                mdi-cached
              </v-icon>
              ล้าง
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </app-card>
</template>

<script>
export default {
  data() {
    return {
      formValidate: null,
      form: {
        PageIndex: 0,
        LeaveTypeID: '0',
        LeaveStatusID: 'W',
        Month: '0',
        Year: '0',
        Keyword: ''
      },
      title: 'ค้นหา',
      leaveTypeDropdown: [],
      leaveStatusDropdown: []
    }
  },

  computed: {
    leaveMonthDropdown() {
      return [
        {
          text: this.$lang === 'Tha' ? 'ทั้งหมด' : 'All',
          value: '0'
        },
        {
          text: this.$lang === 'Tha' ? 'มกราคม' : 'January',
          value: '1'
        },
        {
          text: this.$lang === 'Tha' ? 'กุมภาพันธ์' : 'February',
          value: '2'
        },
        {
          text: this.$lang === 'Tha' ? 'มีนาคม' : 'March',
          value: '3'
        },
        {
          text: this.$lang === 'Tha' ? 'เมษายน' : 'April',
          value: '4'
        },
        {
          text: this.$lang === 'Tha' ? 'พฤษภาคม' : 'May',
          value: '5'
        },
        {
          text: this.$lang === 'Tha' ? 'มิถุนายน' : 'June',
          value: '6'
        },
        {
          text: this.$lang === 'Tha' ? 'กรกฎาคม' : 'July',
          value: '7'
        },
        {
          text: this.$lang === 'Tha' ? 'สิงหาคม' : 'August',
          value: '8'
        },
        {
          text: this.$lang === 'Tha' ? 'กันยายน' : 'September',
          value: '9'
        },
        {
          text: this.$lang === 'Tha' ? 'ตุลาคม' : 'October',
          value: '10'
        },
        {
          text: this.$lang === 'Tha' ? 'พฤศจิกายน' : 'November',
          value: '11'
        },
        {
          text: this.$lang === 'Tha' ? 'ธันวาคม' : 'December',
          value: '12'
        }
      ]
    },

    leaveYearDropdown() {
      const yearList = [
        {
          text: this.$lang === 'Tha' ? 'ทั้งหมด' : 'All',
          value: '0'
        }
      ]
      const currentYear = parseInt(new Date().toISOString().substr(0, 4))
      const additionYear = this.$lang === 'Tha' ? 543 : 0
      for (let i = -1; i <= 1; i++) {
        yearList.push({
          text: currentYear + i + additionYear,
          value: (currentYear + i + 543).toString()
        })
      }
      return yearList.reverse()
    }
  },
  // props: ['title'],
  watch: {
    $route() {
      this.setForm()
    },

    form: {
      handler(newVal) {
        for (let key in newVal) {
          if (newVal[key] === null || newVal[key] === undefined) {
            this.form[key] = ''
          }
        }
      },
      deep: true
    }
  },

  async mounted() {
    this.setForm()
    this.leaveTypeDropdown = await this.apiGetFormTypeList()
    this.leaveStatusDropdown = await this.apiGetFormStatusList()
  },

  methods: {
    setForm() {
      this.form = { ...this.form, ...this.$route.query }
    },

    onSearch() {
      this.$router.push({ query: this.form }).catch(() => {
        console.log('same page, same result')
      })
    },

    async onClear() {
      this.form = {
        PageIndex: 0,
        LeaveTypeID: '0',
        LeaveStatusID: 'W',
        Month: '0',
        Year: '0',
        Keyword: ''
      }
      this.$router.push({ query: {} }).catch(() => {
        console.log('same page, same result')
      })
    },

    async apiGetFormTypeList() {
      try {
        const res = await this.$store.dispatch('leave/getFormTypeList')
        return (
          res.data.data.map(item => {
            return {
              value: item.leaveTypeID.toString(),
              text: item.leaveTypeNameTha
            }
          }) || []
        )
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiGetFormStatusList() {
      try {
        const res = await this.$store.dispatch('leave/getFormStatusList')
        return [
          {
            value: '0',
            text: '---ไม่ระบุ---'
          },
          ...(res.data.data.map(item => {
            return {
              value: item.leaveStatusID,
              text: item.leaveStatusNameTha
            }
          }) || [])
        ]
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
